import httpClient from "../axiosBase/axiosHandler";

export const createConnection = (payload) => {
  return httpClient.post("/marketplaces/connections/", payload);
};

export const updateConnection = ({ id, data }) => {
  return httpClient.patch(`/marketplaces/connections/${id}/`, data);
};

export const getMarketPlaceConnections = () => {
  return httpClient.get("/marketplaces/connections/");
};

export const getStoresMappingList = (queries) => {
  return httpClient.get(`/marketplaces/stores/mapping-list/${queries}`);
};

export const getMarketPlaceStores = (queries) => {
  return httpClient.get(`/marketplaces/stores/${queries}`);
};

export const marketPlaceStoresMapping = ({ data, queries }) => {
  return httpClient.post(`/marketplaces/stores/mapping/${queries}`, data);
};

export const marketPlaceProductsMapping = ({ data, queries }) => {
  return httpClient.post(`/marketplaces/products/mapping/${queries}`, data);
};

export const marketPlaceUpdateProductsMapping = ({ data, queries }) => {
  return httpClient.patch(
    `/marketplaces/products/mapping/update/${queries}`,
    data,
  );
};

export const deleteMarketplaceStoresMapping = (id) => {
  return httpClient.delete(`/marketplaces/stores/mapping/${id}`);
};

export const getMarketPlaceProducts = (queries) => {
  return httpClient.get(`/marketplaces/products/${queries}`);
};

export const getMarketPlaceLumiProducts = (queries) => {
  return httpClient.get(`/marketplaces/products/lumi/${queries}`);
};

export const getMappedUnmappedProducts = (queries) => {
  return httpClient.get(`/marketplaces/products/mapped-unmapped/${queries}`);
};
